module.exports = __webpack_public_path__ + "static/img/06.d6c2b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/06.jpg
// module id = ZNac
// module chunks = 0